<template>
  <div :class="['topbar',locale=='HE' ? 'rtl':'', 'pr-xl', isAtTop ? 'at-top' : '']">
    <router-link class="logo" to="/">
      <img src="/img/logo.svg" alt="" />
      <!-- <img src="/img/logo.jpg" alt="" /> -->
      <!-- <img v-else src="/img/logo_white.png" alt="" /> -->
    </router-link>
    <template v-if="user">
      <router-link class="new-order-btn ml-s" to="/order">
        <i class="fal fa-plus mr-s"></i>
        <span>{{localize('new_order')}}</span>
      </router-link>
      <span class="user-menu-btn ml-xl" v-if="isMcenter" v-text="`${user.FirstName} ${user.LastName}`"></span>
      <span
        class="user-menu-btn ml-xl"
        v-else
        v-text="
          user.IsClinic
            ? `${user.ClinicName} (${user.ClinicBranch})`
            : `Dr. ${user.FirstName} ${user.LastName}`
        "
      ></span>

      <!-- //////// Langauges Toggle //////// -->
      <span v-if="appSettings && appSettings.ShowLangMenu===true" :class="['lang-toggle','ml-xl',langMenuActive ? 'active' : '']"  @click.stop="langMenuActive = !langMenuActive">{{locale}}</span>
      <transition name="slide-down-list" appear>
        <ul v-if="langMenuActive" class="user-menu" @click.stop="langMenuActive = !langMenuActive" v-click-outside="langMenuOut">
          <li>
            <a @click.prevent="changeLang('EN')" href="#p">
              <img class="menu-flag" src="img/flags/us.svg"><span>English</span>
            </a>
          </li>
          <li>
            <a @click.prevent="changeLang('FR')" href="#p">
              <img class="menu-flag" src="img/flags/fr.svg"><span>Français</span>
            </a>
          </li>
          <li>
            <a @click.prevent="changeLang('DE')" href="#p">
              <img class="menu-flag" src="img/flags/de.svg"><span>Deutsch</span>
            </a>
          </li>
          <li>
            <a @click.prevent="changeLang('ES')" href="#p">
              <img class="menu-flag" src="img/flags/es.svg"><span>Español</span>
            </a>
          </li>
          <li>
            <a @click.prevent="changeLang('RU')" href="#p">
              <img class="menu-flag" src="img/flags/ru.svg"><span>Русский</span>
            </a>
          </li>
          <li>
            <a @click.prevent="changeLang('PL')" href="#p">
              <img class="menu-flag" src="img/flags/pl.svg"><span>Polski</span>
            </a>
          </li>
          <!--
          <li>
            <a @click.prevent="changeLang('HE')" href="#p">
              <img class="menu-flag" src="img/flags/he.svg"><span>Hebrew</span>
            </a>
          </li>
          -->


        </ul>
      </transition>

      <!-- //////// Toggle Notifications List ////////-->
      <!-- :class="['notifications','ml-xl',hasNotifications ? 'has-notifications' : 'disabled']"-->
      <a v-if="$device !== 'mobile'"
        @click.stop="notificationsMenuActive = !notificationsMenuActive"
        :class="['notifications','ml-xl',hasNewNotifications ? 'has-notifications' : '']"
        v-tooltip.bottom-end="{container: false,content: bellTooltip}"><i :class="['fal', 'fa-bell']"></i></a>
      <transition name="slide-down-list" appear>
        <notifications-bar  
          @closed="msgsMenuOut" 
          v-if="notificationsMenuActive">
        </notifications-bar>
      </transition>

      <!-- menu toggle -->
      <span :class="['hamburger','ml-xl',userMenuActive ? 'active' : '']" @click.stop="userMenuActive = !userMenuActive"></span>
      <transition name="slide-down-list" appear>
        <ul
          v-if="userMenuActive" :class="['user-menu',locale=='HE' ? 'rtl':'']" @click.stop="userMenuActive = !userMenuActive"
          v-click-outside="userMenuOut">
          <li>
            <router-link to="/editaccount">
              <i class="fal fa-user-edit"></i><span>{{localize('account_info')}}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/contact">
              <i class="fal fa-user-headset"></i><span>{{localize('contact_us')}}</span>
            </router-link>
          </li>
          <li>
            <a @click.prevent="userLogout" href="#p">
              <i class="fal fa-power-off"></i><span>{{localize('log_out')}}</span></a>
          </li>

          <!--
          <li><a @click.prevent="changeLang('EN')" href="#p"><span>English</span></a></li>
          <li><a @click.prevent="changeLang('FR')" href="#p"><span>French</span></a></li>
          <li><a @click.prevent="changeLang('DE')" href="#p"><span>German</span></a></li>
          <li><a @click.prevent="changeLang('RU')" href="#p"><span>Russian</span></a></li>
          <li><a @click.prevent="changeLang('SP')" href="#p"><span>Spanish</span></a></li>
          -->

        </ul>
      </transition>
    </template>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { mapState, mapGetters, mapActions } from "vuex";
import NotificationsBar from "@/components/NotificationsBar.vue";

export default {
  components:{NotificationsBar},
  data() {
    return {
      appSettings:[],
      timer: -1,
      topbarOffset: 20,
      topbarOffsetTop: 0,
      topbarInt: -1,
      userMenuActive: false,
      langMenuActive:false,
      notificationsMenuActive: false,
      hasNotifications: false,
      intersectionOptions: {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: [0.99, 0.2]
      }
    };
  },
  watch: {
    userMenuActive() {
      if (this.userMenuActive) {
        console.log("usermenu active");
        // this.timer = setTimeout(
        //   function() {
        //     this.userMenuActive = false;
        //   }.bind(this),
        //   3000
        // );
      }
    }
  },
  directives: {
    ClickOutside
  },
  mounted() {
    this.appSettings = APP_SETTINGS;
    window.addEventListener("scroll", this.scrollHandler, false);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandler, false);
  },
  methods: {
    ...mapActions(["userLogout","setLocale","setLoadingLayer"]),
    changeLang(langCode)
    {
      this.setLocale(langCode);
      this.$router.go(0);
    },

    // menuClicked() {
    //   if (this.userMenuActive) {
    //     this.userMenuActive = false;
    //   }
    // },
    userMenuOut: _.debounce(function() {
      this.userMenuActive = false;
    }, 300),
    msgsMenuOut: _.debounce(function() {
      this.notificationsMenuActive = false;
    }, 300),
    langMenuOut: _.debounce(function() {
      this.langMenuActive = false;
    }, 300),


    scrollHandler: _.debounce(
      function(e) {
        this.userMenuActive = false;
        this.topbarOffsetTop = this.$el.offsetTop;
        clearInterval(this.topbarInt);
        // console.log(this.$el.offsetTop);
        if (e.eventPhase === 3) {
          clearInterval(this.topbarInt);
          // IN MOTION...
          this.topbarInt = setInterval(
            function() {
              this.topbarOffsetTop = this.$el.offsetTop;
              // if (this.$el.offsetTop > 100) {
              //   console.log("OVER THRES", this.isAtTop);
              // } else {
              //   console.log("BACK TO BAY");

              // }
            }.bind(this),
            120
          );
        } else {
          // this.$set(this, "topbarOffsetTop", this.$el.offsetTop);
          this.topbarOffsetTop = this.$el.offsetTop;
          clearInterval(this.topbarInt);
        }
        // console.log("scrolltop > ", e.eventPhase);
      },
      350,
      { leading: true }
    )
  },
  computed: {
    ...mapState(["user", "$device","notifications","locale"]),
    // ...mapState(["$device"]),
    ...mapGetters(["isMcenter", "isDistributor"]),
    isAtTop() {
      return this.topbarOffsetTop < this.topbarOffset;
    },
    hasNewNotifications(){
      var unreadItems = _.filter(this.notifications,{msg_status:0})
      return unreadItems.length >0 ? true :false;
    },
    bellTooltip()
    {
      return this.hasNewNotifications ? null : this.localize('no_new_notifications');
    }

  }
};
</script>

<style scoped>
  .lang-toggle
  {
    text-transform: uppercase;color:#fff;cursor: pointer;opacity: 0.8;
  }
  .lang-toggle:hover
  {
    opacity: 1;
  }
  .menu-flag
  {
    width: 20px;height: auto;margin-right: 10px;
  }
  .msgsScroll
  {
    clear: both;
  }
  .msgItem
  {
    padding: 20px;
    list-style: none;
    clear: both;
    border-bottom: solid 1px #ccc;
  }
  .msgItem.new 
  {
    background-color: #edf8ff;
  }
  .msgDate
  {
    clear: both;
    font-size: 11px;
    display: block;
    color:#0076c0;
  }
  .msgText
  {
    clear: both;
    font-size: 14px;
    display: block;
  }
  .msgBtn
  {
    background-color: #0076c0;
    font-size: 11px;
    color:#fff;    
    display: inline;
    padding: 2px 12px;
    position: relative;
    top: 3px;
    font-weight: 500;
    cursor: pointer;
  }

</style>

<style lang="stylus" scoped>
.topbar  
  direction ltr
  position sticky
  //background blue_brand
  background linear-gradient(90deg, rgba(5,95,156,1) 0%, rgba(30,144,221,1) 86%, rgba(30,144,221,1) 100%)
  top 0
  left 0
  width 100%
  border-bottom 1px solid blue_brand
  transition border 0.4s ease-out
  // &:before
  //   content ''
  //   z-index 212
  //   top 0
  //   left 0
  //   position absolute
  //   width 100%
  //   height 100%
  //   background linear-gradient(to bottom, #fff  75%, rgba(255,255,255,0.5))
  &.at-top
    border-bottom 1px solid transparent
  _flex(row, wrap, center, flex-end)
  z-index 11111111111
  // z-index 999999999999
  height 85px
  +below(815px)
    height 60px
  // /.logged-out &
  //   border-bottom 1px solid #CFBF8C
  .logo
    position absolute
    left 0
    top 50%
    transform translateY(-50%)
    max-width 220px
    marg('xl', left)
    z-index 213
    +below(815px)
      max-width 120px
    img
      width 100%    
  .notifications
    translate3d(0,0,0)
    transform-style preserve-3d
    position relative
    z-index 213
    i
      opacity 0.8
      color #fff
      font-size responsive 14px 28px
      //-webkit-text-stroke 1px #0076c0
    &.has-notifications
      cursor pointer
    &.has-notifications:before
      content ''
      round(10)
      position absolute
      top 0
      left 60%
      background green_2
  a
    color #fff
    &.new-order-btn
      //border 1px solid green_primary
      border 1px solid white
      border-radius 34px
      padding 6px 12px
      font-size 14px
      font-weight 300
      transition background 0.2s ease-out
      &:hover
        //background green_primary
        border 1px solid blue_brand
        background blue_brand
        span
        i
          color #fff !important
.user-menu-btn
  color #fff
  font-size 18px
  z-index 213
  +below(815px)
    font-size 14px

/*
	Hamburger Menu Styling (icon modes)
*/
.hamburger
	transition width 0.25s ease-out, margin-right 0.25s ease-out, color 0.25s ease-out, border-color 0.25s ease-out
	width 30px
	height 20px
	color #2e2e2e
	border-top 2px solid rgba(#fff, 0.7)
	border-bottom 2px solid rgba(#fff, 0.7)
	position relative
	cursor pointer
	border-radius 0px
	user-select none
	z-index 213
	&:after
	&:before
		transition width 0.25s ease-out-back, background-color 0.25s ease-out, transform 0.25s ease-out, left 0.25s ease-out
		content ''
		width 100%
		position absolute
		top 50%
		left 0
		transform translate(0,-50%)
		height 2px
		background rgba(#fff, 0.5)
	+desktop()
		&:hover
			border-color rgba(#fff, 0.7)
			&:after
				background rgba(#fff, 0.7)
	&.active
		border 0
		&:after
			background-color rgba(#fff, 0.9)
			left 50%
			transform translate(-50%,-50%) rotate(45deg)
		&:before
			background-color rgba(#fff, 0.9)
			left 50%
			transform translate(-50%,-50%) rotate(-45deg)
		+desktop()
			&:hover
				border-color rgba(#fff, 0.9)
				&:after
				&:before
					// transition width 400ms ease-out-back, background-color 400ms ease
					background rgba(#fff, 0.9)
					width 105%
.user-menu
  &.rtl
    direction rtl
  position absolute
  top 101%
  right 0
  transform translate3d(0,0,0)
  transform-style preserve-3d
  will-change transform
  width 300px
  background #fff
  // marg(xl, right)
  pad('s', y)
  border-left 1px solid blue_brand
  box-shadow 1px 1px 12px rgba(gray_6, 0.25)
  border-radius 0 0 0 4px
  backface-visibility hidden
  z-index 211
  li
    margin-bottom 2px
    padding 8px
    // width 64%
    margin 0 auto
    padding 16px 8px
    _flex(row, nowrap, center, flex-start)
    &:not(:last-child)
      border-bottom 1px solid gray_3
    a
      color #fff
      font-size 13px
      display block
      width 100%
      height 100%
      _flex(row, nowrap, center, flex-start)
    i
      color blue_brand
      font-size 160%
      marg('s', right)
      width 30px
      text-align center
    span
      color gray_7
      letter-spacing -0.3px
      transition color 0.3s ease-out
    &:hover span
      color blue_brand

.msgs-menu
  position absolute
  top 101%
  right 0
  transform translate3d(0,0,0)
  transform-style preserve-3d
  will-change transform
  width 280px
  background #fff
  // marg(xl, right)
  //pad('s', y)
  //border-left 1px solid blue_brand
  box-shadow 1px 1px 12px rgba(gray_6, 0.25)
  border-radius 0 0 0 4px
  backface-visibility hidden
  z-index 211
  height 100vh
  overflow-y scroll


// transition
.slide-down-list
	&-enter-active
    transition opacity 0.38s ease-out-cubic, transform 0.38s ease-out-cubic
	&-leave-active
    transition opacity 0.38s ease-in-out-cubic, transform 0.38s ease-in-out-cubic
	&-enter
	&-leave-to
    opacity 0
    transform translateX(100%)
    // box-shadow 3px 5px 12px rgba(gray_6, 0)
	&-enter-to
	&-leave
    opacity 1
    transform translateX(0)
    // box-shadow 3px 5px 12px rgba(gray_6, 0.2)
</style>
<style lang="stylus" scoped>
.hamburger
 +below(815px)
    width 38px
    height 24px
.out-link
  opacity 0.7
  transition opacity 0.3s ease-out
  i
    font-size responsive 14px 28px
    -webkit-text-stroke 1px blue_brand
  &:hover
    opacity 1 !important
</style>
